<div class="gtgt-box hmf-display-flex hmf-flex-column">
  <div class="gtgt-heading hmf-display-flex hmf-justify-content-center hmf-align-items-center">
    <div class="hmf-display-flex hmf-justify-content-center hmf-align-items-center hmf-text-align-center mt-1" [ngStyle]="{'color': textColor() }">
      <span>
        <img
          class="gtgt-image mr-3"
          src="https://dks.scene7.com/is/image/dksfed/{{ gtgtContent()?.image }}?wid=40"
          loading="lazy"
          [alt]="gtgtContent()?.altText || 'Guaranteed to Get There'">
        {{ gtgtContent()?.headline }}
      </span>
    </div>
  </div>

  <div class="hmf-display-flex hmf-justify-content-center hmf-align-items-center gtgt-body mb-3">
    <div [ngStyle]="{'color': textColor() }">{{ gtgtContent()?.Subhead }}&nbsp;</div>@if (displayLink()) {
    <div><a class="link" [href]="gtgtContent()?.link" target="_blank"><span>{{ gtgtContent()?.linkTitle }}</span></a></div>
  }
</div>
</div>
